import useDemandStudio from "../../hooks/useDemandStudio";
import DemandStudioLayout from "./DemandStudioLayout";

const DemandStudio = () => (
  <DemandStudioLayout useStudioState={useDemandStudio} />
);

export default DemandStudio;
